import { h, render, Component, createRef } from 'preact';
import { classNames } from '../utils/utils';

class TxrPopupVideo extends Component {
    state = {
        isOpened: false
    }
    ref = createRef();
    refContent = createRef();
    componentDidMount() {
        setTimeout(() => {
            if(this.props.triggerIds) {
                const triggerIds = this.props.triggerIds.split(',');
                Array.from(triggerIds).forEach((triggerId) => {
                    const el = document.getElementById(triggerId);
                    el.onclick = () => {
                        this.lightboxOpen();
                    };
                });
            }
        }, 1000);
    }

    lightboxOpen = () => {
        this.setState({ isOpened: true });
        if (this.ref.current) {
            this.ref.current.play();
        }
    }

    lightboxClose = () => {
        this.setState({ isOpened: false });
        if (this.ref.current) {
            this.ref.current.pause();
        }
    }
    createMarkup = () => {
        return { __html: this.props.content };
    }

    render() {
        return (
            <div class={'txr-popup-video' + (this.state.isOpened ? ' txr-show-video' : '')}>
                <div class="txr-popup-video-light" >
                    <i class="txr-popup-video-boxclose fal fa-times" onClick={this.lightboxClose}></i>
                    <video ref={this.ref}  controls>
                        <source src={this.props.src} type="video/mp4" />
                    </video>
                </div>
                <div class="txr-popup-video-fade" onClick={this.lightboxClose}></div>
                <div class="txr-popup-video__button" onClick={this.lightboxOpen}></div>
                <div class="txr-popup-video-content" ref={this.refContent} onClick={this.lightboxOpen} dangerouslySetInnerHTML={this.createMarkup()}></div>

            </div>
        )
    }
}

export default TxrPopupVideo;